import { styled } from '@mui/material';

import { Box } from '../../atoms/Box';
import { TextField } from '../../atoms/TextField';
import { Typography } from '../../atoms/Typography';

import { COLORS } from '../../../configs/colors';

export const StyledTypography = styled(Typography)((props: { color: string; fontSize: string }) =>`
  color: ${props.color};
  font-size: ${props.fontSize};
  padding: 3px !important;
`);

export const StyledTextField = styled(TextField)`
  input {
    padding: 2px 6px!important;
  }
`;

export const LocationSearchBox = styled(Box)`
  width: 50%;
  border: 2px solid ${COLORS.CardBorder};
  border-radius: 5px;
  background-color: ${COLORS.CardBackground};
  box-sizing: border-box;
`;